import { attachIdentify } from '@updater-core/lib/optimizely';

export const setupSegment = ({ interactors: { session } = {} }) => {
  if (window.analytics) {
    attachIdentify(({ id, traits }) => window.analytics.identify(id, traits));
  }

  session.subscribe((state) => {
    const uuid = session.selectors.uuid(state);

    if (window.analytics && uuid) {
      window.analytics.identify(uuid, {
        firstName: session.selectors.userFirstName(state),
        lastName: session.selectors.userLastName(state),
        email: session.selectors.userEmail(state),
        phone: session.selectors.userPhoneNumber(state),
      });
    } else if (window.analytics) {
      window.analytics.reset();
    }
  });
};
